import React from "react";
import { MultiSelect } from "react-multi-select-component";


interface IProps {
  options: any; 
  setSelected: (a: any) => void;
  value?: any[]; 
  limitSelection?: number;
  className?: string;
  label?: string;
  ismandatory?: boolean;
  DefaultLibelle: string;
}

/**
 * Normalise une chaîne en supprimant les accents et les caractères spéciaux
 * @param str - La chaîne à normaliser
 * @returns La chaîne normalisée sans accents ni caractères spéciaux
 */
const normalizeString = (str: string): string => {
  // Supprimer les accents
  const withoutAccents = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // Remplacer les caractères spéciaux (tirets, apostrophes, etc.) par des espaces
  const withoutSpecialChars = withoutAccents.replace(/[-'".,;:!?()[\]{}]/g, " ");
  // Normaliser les espaces multiples en un seul espace
  return withoutSpecialChars.replace(/\s+/g, " ").trim();
};

const MultiSelectComponent: React.FC<IProps> = ({
  options,
  setSelected,
  value = [], 
  className,
  label,
  ismandatory,
  DefaultLibelle
}) => {
  const selectOptions = options?.map((option: { Libelle: any; Id: any; }) => {
    return {
      label: option.Libelle,
      value: option.Id,
    };
  });
  

  const customValueRenderer = (selected: any[], _options: any) => {
    return selected.length
      ? selected.map(({ label }) => label).join(", ")
      : DefaultLibelle;
  };

  /**
   * Fonction de filtrage personnalisée qui ignore les accents et les caractères spéciaux
   * Permet de chercher par mots multiples (chaque mot doit apparaître dans le label)
   */
  const filterOptions = (options: any[], filter: string) => {
    if (!filter) {
      return options;
    }
    
    const normalizedFilter = normalizeString(filter.toLowerCase());
    const filterWords = normalizedFilter.split(" ").filter(word => word.length > 0);
    
    return options.filter((option: { label: string }) => {
      const normalizedLabel = normalizeString(option.label.toLowerCase());
      // Tous les mots du filtre doivent apparaître dans le label
      return filterWords.every(word => normalizedLabel.includes(word));
    });
  };

  return (
    <>
    {label && (
       <label className={`form-label ${className}`}>
       {label} {ismandatory && <em className="text-danger">*</em>}
     </label>
    )}
   
    <MultiSelect
      options={selectOptions}
      value={value}
      className={className}
      onChange={(e: string | any[]) => {
          setSelected(e);
      }}
      labelledBy={DefaultLibelle}
      valueRenderer={customValueRenderer}
      hasSelectAll={true}
      disableSearch={false}
      filterOptions={filterOptions}
      overrideStrings={{
        "selectAll": "Tout sélectionner",
        "selectSomeItems": "Sélectionner des éléments",
        "search": "Rechercher..."
      }}
    />
    </>
    
  );
};

export default MultiSelectComponent;
